import { booking } from "./booking";
import { eventReports } from "./event-reports";

export const event = {
	booking,
	...eventReports,
};
